

















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GMovableLayoutBox',
  props: {
    heading: { type: String as PropType<string> },
    isHidden: { type: Boolean as PropType<boolean>, default: false },
    onDelete: { type: Function as PropType<Function>, required: true },
    onUp: { type: Function as PropType<Function>, required: true },
    onDown: { type: Function as PropType<Function>, required: true },
  },
});
